import { Button } from "@mui/material";
import React from "react";
import GridViewIcon from "@mui/icons-material/GridView";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/Index";
import { showErrorToast } from "../../../../../components/common/ShowToast";

interface Props {
  canvaLink: string | null;
}

export const CanvaLinkButton: React.FC<Props> = ({ canvaLink }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  const openCanvaLink = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    canva_memory_book_link: string | null
  ) => {
    e.stopPropagation();
    if (!canva_memory_book_link) {
      showErrorToast("Canva link not available at the moment");
      return;
    }

    window.open(canva_memory_book_link, "_blank");
  };

  return (
    <Button
      disabled={!canvaLink}
      onClick={(e) => openCanvaLink(e, canvaLink)}
      sx={{
        color: canvaLink ? "#007AFF" : reduxTheme.primary_colors[300],
      }}
    >
      <GridViewIcon sx={{ mr: 1 }} /> Open link
    </Button>
  );
};
